<ng-container *ngIf="driftStatusBeskeder$ | async as driftStatusBeskeder">
  <ng-container *ngIf="driftStatusBeskeder.length > 0">
    <div class="container pt-4 no-print">
      <div class="row" *ngFor="let driftStatusBesked of driftStatusBeskeder">
        <div class="col">
          <bom-alert
            [showIcon]="true"
            [titleHtml]="driftStatusBesked.overskrift"
            [descriptionHtml]="driftStatusBesked.tekst"
            type="warning"
            (closeEvent)="close(driftStatusBesked)"
          >
          </bom-alert>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
